import Player from '@vimeo/player';

export const HomeVideo = (function () {
	"use strict";

	let $videoDesktopContainer, $videoMobileContainer;

	function init() {
		$videoDesktopContainer = $('.home-video__video-desktop');
		$videoMobileContainer = $('.home-video__video-mobile');
		if($videoDesktopContainer.length > 0) {
			renderDesktopVideoControls();
		}
		if($videoMobileContainer.length > 0) {
			renderMobileVideoControls();
		}
	}

	function renderDesktopVideoControls() {
		let $iframe = $videoDesktopContainer.find('iframe');
		const player = new Vimeo.Player($iframe);

		let $pause = $videoDesktopContainer.find('[data-pause]');
		let $play = $videoDesktopContainer.find('[data-play]');
		let $mute = $videoDesktopContainer.find('[data-mute]');
		let $unmute = $videoDesktopContainer.find('[data-unmute]');
		let $replay = $videoDesktopContainer.find('[data-replay]');

		removeAudio(player, false);

		$pause.on('click', function(){
			player.pause();
		});
		$play.on('click', function(){
			player.play();
		});
		$mute.on('click', function(){
			// console.log('muted')
			player.setMuted(true);
		});
		$unmute.on('click', function(){
			// console.log('unmuted')
			player.setMuted(false);
		});
		$replay.on('click', function(){
			// console.log('unmuted')
			player.setCurrentTime(0);
		});

		player.on('pause', function(data) {
			$pause.hide();
			$play.show();
		});
		player.on('play', function(data) {
			$pause.show();
			$play.hide();
		});

		player.on('volumechange', function(data) {
			player.getMuted().then(function(muted) {
				if(muted) {
					$mute.hide();
					$unmute.show();
				} else {
					$mute.show();
					$unmute.hide();
				}
			}).catch(function(error) {
				console.error('See Developer: ', error);
			});
		});		
	}

	function renderMobileVideoControls() {
		let $iframe = $videoMobileContainer.find('iframe');
		const player = new Vimeo.Player($iframe);

		let $pause = $videoMobileContainer.find('[data-pause]');
		let $play = $videoMobileContainer.find('[data-play]');
		let $mute = $videoMobileContainer.find('[data-mute]');
		let $unmute = $videoMobileContainer.find('[data-unmute]');
		let $replay = $videoMobileContainer.find('[data-replay]');

		removeAudio(player, true);

		$pause.on('click', function(){
			player.pause();
		});
		$play.on('click', function(){
			player.play();
		});
		$mute.on('click', function(){
			// console.log('muted')
			player.setMuted(true);
		});
		$unmute.on('click', function(){
			// console.log('unmuted')
			player.setMuted(false);
		});
		$replay.on('click', function(){
			// console.log('unmuted')
			player.setCurrentTime(0);
		});

		player.on('pause', function(data) {
			$pause.hide();
			$play.show();
		});
		player.on('play', function(data) {
			$pause.show();
			$play.hide();
		});

		player.on('volumechange', function(data) {
			player.getMuted().then(function(muted) {
				if(muted) {
					$mute.hide();
					$unmute.show();
				} else {
					$mute.show();
					$unmute.hide();
				}
			}).catch(function(error) {
				console.error('See Developer: ', error);
			});
		});
		
	}

	function removeAudio(player, isMobile) {
		$(window).on("resize", function(event){
			if($(this).width() > 768 && !isMobile) {
				player.setMuted(false);
			} else {
				player.setMuted(true);
			}
		});
	}

	return {
		init: init, 
	};

})(); 
